import React, {useState} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import Toggle from '../../Button/Toggle';
import { usePreference } from '../../../Data/Preference';
import OptionalTimeValidator from '../Validators/OptionalTime';

const noValidators = [];
const enabledValidators = [OptionalTimeValidator];

const OptionalTime = ({label, toggleLabel, name, help, onChange, step, disabled}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const [previouslyToggledOn, setPreviouslyToggledOn] = usePreference('optionalTime:enabled', false);
    const [enabled, setEnabled] = useState(!!(value || previouslyToggledOn));
    const validators = (enabled || value) ? enabledValidators : noValidators;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    useConditionalHelper(name);

    const toggleEnabled = (newVal) => {
        setEnabled(newVal);
        setPreviouslyToggledOn(newVal);
        if (!newVal) {
            handleChange('');
        }
    }

    const handleChange = (newVal) => {
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>
        <Toggle label={toggleLabel} enabled={enabled} onChange={toggleEnabled} />

        {enabled && <TimeField {...{name, value, step, isDisabled, handleChange}} />}

    </CommonFieldWrapper>
}

const TimeField = ({name, value, step, isDisabled, handleChange}) => {
    return <div className="relative flex flex-row mt-2">
        <input className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
            type="time"
            name={name}
            value={value}
            step={step}
            onChange={e => handleChange(e.target.value)}
            disabled={isDisabled}
        />
    </div>
}


export default OptionalTime;
